import { memo } from 'react'
import { useNavigate } from 'react-router-dom'

function HistoryButton({ title, link, isUser = false }) {
  const navigate = useNavigate()
  const addNewCar = () => {
    navigate(`/${link}`)
  }

  return (
    <button
      type={'button'}
      onClick={addNewCar}
      className={`w-full md:w-fit shadow-add-more h-11 mx-auto px-5 py-2.5 text-md font-medium text-white
                white flex items-center justify-center bg-transparent rounded-md border border-blue whitespace-nowrap
                ${isUser && 'mr-auto ml-0'}
                `}
    >
      <span className={'text-blue pl-2'}>{title}</span>
      <i className={'icon-clock text-blue text-xl'} />
    </button>
  )
}

export default memo(HistoryButton)
